import { HTMLAttributes } from "react";
import { NavLink } from "react-router-dom";
import './nav-item.scss';

interface INavItemProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  to: string;
}

export function NavItem({
  title,
  to,
}: INavItemProps) {
  return (
    <NavLink 
      to={to} 
      className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
    >
      <span className='nav-item-title'>
        {title}
      </span>
    </NavLink>
  );
}